
export class ColaboradorEstudio {
    colaboradorestudioid: number = 0;
    colaboradorid: number = 0;
    escolaridadid: number = 0;
    estatusestudioid: number = 0;
    titulo: string = "";
    institucioneducativa: string = "";
    cedulaprofesional: string = "";


    constructor(init?: Partial<ColaboradorEstudio>) {
        Object.assign(this, init);
    }
}
